import * as React from 'react';

export const useSelectHelpers = () => {
  const extractTextContentFromReactNode = (node: React.ReactNode): string => {
    if (node === null || node === undefined) {
      return '';
    }

    if (typeof node === 'string' || typeof node === 'number') {
      return String(node);
    }

    if (typeof node === 'boolean') {
      return '';
    }

    if (Array.isArray(node)) {
      return node.map(extractTextContentFromReactNode).join('');
    }

    if (React.isValidElement(node)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      return extractTextContentFromReactNode((node.props as any)?.children);
    }

    return '';
  };

  return {
    extractTextContentFromReactNode,
  };
};
